const KLAVIYO_REVISION = '2026-01-15';

if (!customElements.get('collection-klaviyo-bis')) {
  customElements.define(
    'collection-klaviyo-bis',
    class CollectionKlaviyoBis extends HTMLElement {
      constructor() {
        super();
        this._onOverlayClick = this._onOverlayClick.bind(this);
        this._onCloseClick = this._onCloseClick.bind(this);
        this._onFormSubmit = this._onFormSubmit.bind(this);
      }

      connectedCallback() {
        this.modal = this.querySelector('#collection-lp-bis-modal');
        this.overlay = this.querySelector('#collection-lp-bis-overlay');
        this.closeBtn = this.querySelector('#collection-lp-bis-close');
        this.form = this.querySelector('#collection-lp-bis-form');
        this.emailIn = this.querySelector('#collection-lp-bis-email');
        this.submitBtn = this.querySelector('#collection-lp-bis-submit');
        this.submitBtnOriginalText = this.submitBtn ? this.submitBtn.textContent.trim() : 'NOTIFY ME';
        this.errEl = this.querySelector('#collection-lp-bis-err');
        this.successEl = this.querySelector('#collection-lp-bis-success');
        this.titleEl = this.querySelector('#collection-lp-bis-title');
        this.variantDataEl = this.querySelector('#collection-bis-variant-data');
        this.variantInput = this.querySelector('#collection-bis-variant-input');
        this.marketingCb = this.querySelector('#collection-lp-bis-marketing');

        if (this.overlay) this.overlay.addEventListener('click', this._onOverlayClick);
        if (this.closeBtn) this.closeBtn.addEventListener('click', this._onCloseClick);
        if (this.form) this.form.addEventListener('submit', this._onFormSubmit);
      }

      disconnectedCallback() {
        if (this.overlay) this.overlay.removeEventListener('click', this._onOverlayClick);
        if (this.closeBtn) this.closeBtn.removeEventListener('click', this._onCloseClick);
        if (this.form) this.form.removeEventListener('submit', this._onFormSubmit);
      }

      get companyId() {
        return (this.dataset.klaviyoCompanyId || '').replace(/\s+/g, '');
      }

      get listId() {
        return (this.dataset.klaviyoMarketingListId || '').replace(/\s+/g, '');
      }

      /**
       * @param {{ productTitle: string, variants: Array<object>, variantId: string|number }} ctx
       */
      openForVariant(ctx) {
        const { productTitle, variants, variantId } = ctx || {};
        if (!this.modal || !this.variantDataEl || !this.variantInput) return;
        const vId = variantId != null ? String(variantId) : '';
        if (!vId || !variants || !Array.isArray(variants)) return;

        try {
          this.variantDataEl.textContent = JSON.stringify(variants);
        } catch {
          return;
        }
        this.variantInput.value = vId;
        if (this.titleEl && productTitle) {
          this.titleEl.textContent = productTitle;
        }
        this.showErr('');
        if (this.form) this.form.reset();
        if (this.marketingCb) this.marketingCb.checked = true;
        if (!this.companyId) this.showErr('Add your Klaviyo public API key in the Collection section settings.');
        if (this.submitBtn) this.submitBtn.disabled = !this.companyId;
        if (this.emailIn && this.companyId) this.emailIn.focus();

        this.modal.classList.add('lp-pdp__guidelines-modal--active');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      closeModal() {
        if (!this.modal) return;
        this.modal.classList.remove('lp-pdp__guidelines-modal--active');
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        this.showErr('');
        if (this.form) {
          this.form.reset();
          this.form.hidden = false;
        }
        if (this.successEl) this.successEl.hidden = true;
        if (this.submitBtn) {
          this.submitBtn.disabled = false;
          this.submitBtn.textContent = this.submitBtnOriginalText;
        }
      }

      currentVariant() {
        const sel = this.variantInput;
        const el = this.variantDataEl;
        if (!sel || !el) return null;
        let data;
        try {
          data = JSON.parse(el.textContent || '[]');
        } catch {
          return null;
        }
        return data.find((v) => String(v.id) === String(sel.value)) || null;
      }

      showErr(msg) {
        if (!this.errEl) return;
        this.errEl.textContent = msg || '';
        this.errEl.hidden = !msg;
      }

      showSuccess() {
        if (this.form) this.form.hidden = true;
        if (this.successEl) this.successEl.hidden = false;
        setTimeout(() => this.closeModal(), 1500);
      }

      _onOverlayClick() {
        this.closeModal();
      }

      _onCloseClick() {
        this.closeModal();
      }

      klaviyoPost(path, body) {
        const headers = new Headers();
        headers.set('Content-Type', 'application/vnd.api+json');
        headers.set('revision', KLAVIYO_REVISION);
        return fetch(
          `https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(this.companyId)}`,
          { method: 'POST', headers, body: JSON.stringify(body) },
        );
      }

      _onFormSubmit(e) {
        e.preventDefault();
        if (!this.companyId || !this.emailIn || !this.submitBtn) return;
        const v = this.currentVariant();
        if (!v || v.available) return;
        const email = (this.emailIn.value || '').trim();
        if (!email || !this.emailIn.checkValidity()) {
          this.emailIn.reportValidity();
          return;
        }

        const bisBody = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email } } },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${String(v.id)}`,
                },
              },
            },
          },
        };

        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'Sending…';
        this.showErr('');

        this.klaviyoPost('back-in-stock-subscriptions', bisBody)
          .then((res) => {
            if (res.status !== 202) {
              return res.text().then((t) => {
                let d;
                try {
                  const j = JSON.parse(t);
                  if (j.errors && j.errors[0]) d = j.errors[0].detail || j.errors[0].title;
                } catch {
                  d = t ? t.slice(0, 100) : '';
                }
                this.showErr(d || 'Could not subscribe. Try again.');
              });
            }
            if (this.marketingCb && this.marketingCb.checked && this.listId) {
              this.klaviyoPost('subscriptions', {
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: 'Collection quick add modal',
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email,
                          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                        },
                      },
                    },
                  },
                  relationships: { list: { data: { type: 'list', id: this.listId } } },
                },
              }).catch(() => {});
            }
            this.showSuccess();
          })
          .catch(() => {
            this.showErr('Could not reach Klaviyo. Check your connection and try again.');
          })
          .finally(() => {
            this.submitBtn.disabled = false;
            this.submitBtn.textContent = this.submitBtnOriginalText;
          });
      }
    },
  );
}
